export const initialState = {
    parentQuestionsOptions: [],
    filterHarvest: 1
};

const checkAgroV2 = (state = initialState, actions) => {
    switch (actions.type) {
        case 'SET_PARENT_QUESTIONS_OPTIONS':
            return {
                ...state,
                parentQuestionsOptions: actions.payload
            };
        case 'SET_FILTER_HARVEST':
            return {
                ...state,
                filterHarvest: actions.payload
            };
        default:
            return state;
    }
};

export default checkAgroV2;
